import { QueryClient } from '@tanstack/react-query';
// The one QueryClient for the app. It lives here (not in main.tsx) so
// non-React code — the logout path, the expired-token handler — can wipe it:
// every cached query is scoped to whoever was logged in, and a second user on
// the same browser tab must never see the first user's cars, orders or email.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,
            retry: 1
        }
    }
});
